module.exports = __webpack_public_path__ + "static/5-87673cacaa56594c8cfe851a35002f25.jpg";